import { TIMEZONE } from '@autobid/ui/constants/TIMEZONE'

export function formatDate(date: Date | string) {
  const _date = typeof date === 'string' ? new Date(date) : date

  return _date
    .toLocaleDateString('en-GB', { timeZone: TIMEZONE })
    .replace(/\//g, '.')
}
